import { call, put } from 'redux-saga/effects';
import { handleServerError } from 'store/alerts/actions';
import { fetchCategoriesApi } from 'store/giftCards/api';
import { receiveCategories } from 'store/giftCards/actions';

function* fetchCategoriesWorker() {
  try {
    const { data } = yield call(fetchCategoriesApi);

    yield put(receiveCategories(data?.data || []));
  } catch (error) {
    yield put(handleServerError(error));
    yield put(receiveCategories([]));
  }
}

export default fetchCategoriesWorker;
